'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectCareerCategories = function selectCareerCategories(_ref, jobs) {
  var title = _ref.title,
      categories = _ref.categories;
  return {
    title: title || 'Careers in Financial Services',
    categories: categories.map(function (category) {
      return {
        href: category.href,
        icon: category.icon,
        label: category.label,
        jobs: category.jobs.map(function (slug) {
          return (0, _extends3.default)({}, jobs[slug]);
        })
      };
    })
  };
};

var selectApp = function selectApp(_ref2) {
  var _ref2$site = _ref2.site,
      title = _ref2$site.title,
      logo = _ref2$site.logo,
      footer = _ref2$site.footer,
      navigation = _ref2$site.navigation,
      headerTagline = _ref2$site.headerTagline,
      headerTagline2 = _ref2$site.headerTagline2,
      headerHeadline = _ref2$site.headerHeadline,
      jobs = _ref2.data.jobs;

  return {
    title: title,
    logo: logo,
    footer: (0, _extends3.default)({}, footer, {
      careerCategories: selectCareerCategories(footer.careerCategories, jobs)
    }),
    navigation: navigation,
    headerTagline: headerTagline,
    headerTagline2: headerTagline2,
    headerHeadline: headerHeadline
  };
};

var getPath = function getPath(path) {
  return path ? '/' + path : '/';
};

var selectBackgroundImage = function selectBackgroundImage(_ref3, path) {
  var backgroundImages = _ref3.backgroundImages;

  return (backgroundImages || []).reduce(function (foundImage, _ref4) {
    var slug = _ref4.slug,
        href = _ref4.href;

    if (foundImage) {
      return foundImage;
    }

    /* search for background slug in current path */
    var regex = new RegExp('\/' + slug);

    if (regex.test(path == '/' ? '/homepage' : path)) {
      return href;
    }

    /* Use 'default' background image if none set */
    var defaultHref = null;
    if (slug == 'default') defaultHref = href;

    return defaultHref;
  }, null);
};

var selectClasses = function selectClasses() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return [path.split('/').join('-'), path.split('/').filter(function (el) {
    return el;
  }).shift()];
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref5) {
  var params = _ref5.params;

  return (0, _extends3.default)({}, selectApp(state), {
    backgroundImage: selectBackgroundImage(state.content, getPath(params.splat)),
    classes: selectClasses(params.splat)
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/App/selectors.js
// module id = 1146
// module chunks = 0